<form [formGroup]="countryForm">
  <div class="flex-space-between">
    <glxy-form-field class="flex-1" appearance="outline">
      <glxy-label>{{ 'BANK_ACCOUNT.ADD.BANK_ACCOUNT' | translate }}</glxy-label>
      <mat-select formControlName="country">
        <mat-option *ngFor="let country of countryOptions" [value]="country.value">
          {{ country.label }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
    <div class="spacer"></div>
    <glxy-form-field *ngIf="country.value === 'CA'" class="flex-1" appearance="outline">
      <glxy-label>{{ 'BANK_ACCOUNT.ADD.CURRENCY' | translate }}</glxy-label>
      <mat-select formControlName="currency">
        <mat-option *ngFor="let c of currencyOptions" [value]="c.value">
          {{ c.label }}
        </mat-option>
      </mat-select>
    </glxy-form-field>
  </div>
</form>

<div>
  @switch (country.value) {
    @case ('CA') {
      <form class="flex-space-between" [formGroup]="canadaForm">
        <!-- Transit Number-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.TRANSIT_NUMBER' | translate }}</glxy-label>
          <input matInput formControlName="transitNumber" placeholder="12345" required />
          <glxy-error
            *ngIf="canadaForm.get('transitNumber').touched && canadaForm.get('transitNumber').hasError('required')"
          >
            {{ 'BANK_ACCOUNT.ADD.TRANSIT_NUMBER_REQUIRED' | translate }}
          </glxy-error>
          <glxy-error
            *ngIf="canadaForm.get('transitNumber').touched && canadaForm.get('transitNumber').hasError('pattern')"
          >
            {{ 'BANK_ACCOUNT.ADD.TRANSIT_NUMBER_INVALID' | translate }}
          </glxy-error>
        </glxy-form-field>
        <div class="spacer"></div>
        <!-- Institution Number-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.INSTITUITON_NUMBER' | translate }}</glxy-label>
          <input matInput formControlName="institutionNumber" placeholder="000" required />
          <glxy-error
            *ngIf="
              canadaForm.get('institutionNumber').touched && canadaForm.get('institutionNumber').hasError('pattern')
            "
          >
            {{ 'BANK_ACCOUNT.ADD.INSTITUITON_NUMBER_INVALID' | translate }}
          </glxy-error>
          <glxy-error
            *ngIf="
              canadaForm.get('institutionNumber').touched && canadaForm.get('institutionNumber').hasError('required')
            "
          >
            {{ 'BANK_ACCOUNT.ADD.INSTITUITON_NUMBER_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
        <div class="spacer"></div>
        <!-- Account Number-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER' | translate }}</glxy-label>
          <input matInput placeholder="000123456789" formControlName="accountNumber" required />
          <glxy-error
            *ngIf="canadaForm.get('accountNumber').touched && canadaForm.get('accountNumber').hasError('pattern')"
          >
            {{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER_INVALID' | translate: { required_digits: '7-17' } }}
          </glxy-error>
          <glxy-error
            *ngIf="canadaForm.get('accountNumber').touched && canadaForm.get('accountNumber').hasError('required')"
          >
            {{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
      </form>
      <div class="secondary-text">{{ 'BANK_ACCOUNT.ADD.REFERENCE_CHEQUE' | translate }}</div>
      <img
        class="cheque"
        src="https://vstatic-prod.apigateway.co/partner-center-client.9223372035099833042.prod/assets/images/cheque-cad.svg"
        alt="canadian-cheque-example"
      />
    }
    @case ('US') {
      <form class="flex-space-between" [formGroup]="unitedStatesForm">
        <!--Routing Number-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.ROUTING_NUMBER' | translate }}</glxy-label>
          <input matInput formControlName="routingNumber" placeholder="123456789" required />
          <glxy-error
            *ngIf="
              unitedStatesForm.get('routingNumber').touched && unitedStatesForm.get('routingNumber').hasError('pattern')
            "
          >
            {{ 'BANK_ACCOUNT.ADD.ROUTING_NUMBER_INVALID' | translate }}
          </glxy-error>
          <glxy-error
            *ngIf="
              unitedStatesForm.get('routingNumber').touched &&
              unitedStatesForm.get('routingNumber').hasError('required')
            "
          >
            {{ 'BANK_ACCOUNT.ADD.ROUTING_NUMBER_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
        <div class="spacer"></div>
        <!-- Account Number-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER' | translate }}</glxy-label>
          <input matInput formControlName="accountNumber" placeholder="000123456789" required />
          <glxy-error
            *ngIf="
              unitedStatesForm.get('accountNumber').touched &&
              unitedStatesForm.get('accountNumber').hasError('required')
            "
          >
            {{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER_REQUIRED' | translate }}
          </glxy-error>
          <glxy-error
            *ngIf="
              unitedStatesForm.get('accountNumber').touched && unitedStatesForm.get('accountNumber').hasError('pattern')
            "
          >
            {{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER_INVALID' | translate: { required_digits: '7-17' } }}
          </glxy-error>
        </glxy-form-field>
      </form>
      <div class="secondary-text">{{ 'BANK_ACCOUNT.ADD.REFERENCE_CHEQUE' | translate }}</div>
      <img
        class="cheque"
        src="https://vstatic-prod.apigateway.co/partner-center-client.9223372035099833042.prod/assets/images/cheque-usd.svg"
        alt="us-cheque-example"
      />
    }
    @case ('CZ') {
      <form class="flex-space-between" [formGroup]="czechRepublicForm">
        <!--IBAN-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.IBAN' | translate }}</glxy-label>
          <input matInput formControlName="iban" placeholder="CZ6508000000192000145399" required />
          <glxy-error
            *ngIf="czechRepublicForm.get('iban').touched && czechRepublicForm.get('iban').hasError('pattern')"
          >
            {{ 'BANK_ACCOUNT.ADD.IBAN_INVALID' | translate: { required_length: '24' } }}
          </glxy-error>
          <glxy-error
            *ngIf="czechRepublicForm.get('iban').touched && czechRepublicForm.get('iban').hasError('required')"
          >
            {{ 'BANK_ACCOUNT.ADD.IBAN_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
      </form>
    }
    @case ('AU') {
      <form class="flex-space-between" [formGroup]="australiaForm">
        <!--BSB-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.BSB' | translate }}</glxy-label>
          <input matInput formControlName="bsb" placeholder="123456" required />
          <glxy-error *ngIf="australiaForm.get('bsb').touched && australiaForm.get('bsb').hasError('pattern')">
            {{ 'BANK_ACCOUNT.ADD.BSB_INVALID' | translate }}
          </glxy-error>
          <glxy-error *ngIf="australiaForm.get('bsb').touched && australiaForm.get('bsb').hasError('required')">
            {{ 'BANK_ACCOUNT.ADD.BSB_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
        <div class="spacer"></div>
        <!--Account Number-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER' | translate }}</glxy-label>
          <input matInput formControlName="accountNumber" placeholder="12345678" required />
          <glxy-error
            *ngIf="australiaForm.get('accountNumber').touched && australiaForm.get('accountNumber').hasError('pattern')"
          >
            {{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER_INVALID' | translate: { required_digits: '5-9' } }}
          </glxy-error>
          <glxy-error
            *ngIf="
              australiaForm.get('accountNumber').touched && australiaForm.get('accountNumber').hasError('required')
            "
          >
            {{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
      </form>
    }
    @case ('NZ') {
      <form class="flex-space-between" [formGroup]="newZealandForm">
        <!--Account Number-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER' | translate }}</glxy-label>
          <input matInput formControlName="accountNumber" placeholder="AABBBB3456789YZZ" required />
          <glxy-error
            *ngIf="
              newZealandForm.get('accountNumber').touched && newZealandForm.get('accountNumber').hasError('pattern')
            "
          >
            {{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER_INVALID' | translate: { required_digits: '15-16' } }}
          </glxy-error>
          <glxy-error
            *ngIf="
              newZealandForm.get('accountNumber').touched && newZealandForm.get('accountNumber').hasError('required')
            "
          >
            {{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
      </form>
    }
    @case ('GB') {
      <form class="flex-space-between" [formGroup]="unitedKingdomForm">
        <!--Sort Code-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.SORT_CODE' | translate }}</glxy-label>
          <input matInput formControlName="sortCode" placeholder="12-34-56" required />
          <glxy-error
            *ngIf="unitedKingdomForm.get('sortCode').touched && unitedKingdomForm.get('sortCode').hasError('pattern')"
          >
            {{ 'BANK_ACCOUNT.ADD.SORT_CODE_INVALID' | translate }}
          </glxy-error>
          <glxy-error
            *ngIf="unitedKingdomForm.get('sortCode').touched && unitedKingdomForm.get('sortCode').hasError('required')"
          >
            {{ 'BANK_ACCOUNT.ADD.SORT_CODE_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
        <div class="spacer"></div>
        <!--Account-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER' | translate }}</glxy-label>
          <input matInput formControlName="account" placeholder="01234567" required />
          <glxy-error
            *ngIf="unitedKingdomForm.get('account').touched && unitedKingdomForm.get('account').hasError('pattern')"
          >
            {{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER_INVALID' | translate: { required_digits: '8' } }}
          </glxy-error>
          <glxy-error
            *ngIf="unitedKingdomForm.get('account').touched && unitedKingdomForm.get('account').hasError('required')"
          >
            {{ 'BANK_ACCOUNT.ADD.ACCOUNT_NUMBER_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
      </form>
    }
    @case ('AE') {
      <form class="flex-space-between" [formGroup]="unitedArabEmiratesForm">
        <!--IBAN-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.IBAN' | translate }}</glxy-label>
          <input matInput formControlName="iban" placeholder="AE070331234567890123456" required />
          <glxy-error
            *ngIf="unitedArabEmiratesForm.get('iban').touched && unitedArabEmiratesForm.get('iban').hasError('pattern')"
          >
            {{ 'BANK_ACCOUNT.ADD.IBAN_INVALID' | translate: { required_length: '23' } }}
          </glxy-error>
          <glxy-error
            *ngIf="
              unitedArabEmiratesForm.get('iban').touched && unitedArabEmiratesForm.get('iban').hasError('required')
            "
          >
            {{ 'BANK_ACCOUNT.ADD.IBAN_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
      </form>
    }
    @case ('DE') {
      <form class="flex-space-between" [formGroup]="germanyForm">
        <!--IBAN-->
        <glxy-form-field class="flex-1" appearance="outline">
          <glxy-label>{{ 'BANK_ACCOUNT.ADD.IBAN' | translate }}</glxy-label>
          <input matInput formControlName="iban" placeholder="DE89370400440532013000" required />
          <glxy-error *ngIf="germanyForm.get('iban').touched && germanyForm.get('iban').hasError('pattern')">
            {{ 'BANK_ACCOUNT.ADD.IBAN_INVALID' | translate: { required_length: '22' } }}
          </glxy-error>
          <glxy-error *ngIf="germanyForm.get('iban').touched && germanyForm.get('iban').hasError('required')">
            {{ 'BANK_ACCOUNT.ADD.IBAN_REQUIRED' | translate }}
          </glxy-error>
        </glxy-form-field>
      </form>
    }
  }
</div>
<glxy-error class="stripe-error" *ngIf="addBankAccountError()">
  {{ addBankAccountError() }}
</glxy-error>
